package com.eladfinish.bible.contest.navigation

import androidx.compose.runtime.Composable
import androidx.navigation.NavType
import com.eladfinish.bible.contest.navigation.NavigationDestination.Companion.Companion.createTypeMap
import kotlinx.serialization.KSerializer
import kotlin.reflect.KType
import kotlin.reflect.typeOf

interface NavigationDestination {

    val title: String?
        @Composable
        get() = null

    val subtitle: String?
        @Composable
        get() = null

    val screenName: String?
        get() = null

    val screenTrackingProperties: Map<String, Any?>?
        get() = null

    interface Companion {

        /**
         * Compose navigation supports passing primitive arguments out of the box (all
         * supported types can be found in [androidx.navigation.NavType.Companion]). If a custom serializable
         * object needs to be passed within a destination model, the [typeMap] should be
         * populated using the [createTypeMap] function. This [typeMap] can then be passed
         * to the [composableAnimated] function as the typeMap parameter.
         */
        val typeMap: Map<KType, NavType<*>>

        companion object {

            inline fun <reified T : Any> createTypeMap(
                vararg types: KSerializer<T>,
            ): Map<KType, NavType<*>> {
                return types.associate {
                    typeOf<T>() to NavTypeSerializer.create(it)
                }
            }
        }
    }
}
